import { EmbedScriptEmbed } from '@graphql/__generated__/graphql';
import { ScriptEmbedProps } from '@stadionhq-v3/base-ui';
import { CleanContentful } from '@stadionhq-v3/clean-contentful';

const scriptEmbedTransform = ({
  scriptEmbed,
}: CleanContentful<EmbedScriptEmbed>): ScriptEmbedProps => ({
  scriptEmbed,
});

export default scriptEmbedTransform;
